import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { LoginForm } from '@/components/auth/LoginForm'
import { ThemeToggle } from '@/components/ui/ThemeToggle'
import { useAuthStore } from '@/lib/store/auth-store'

export function LoginPage() {
  const { isLoggedIn } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoggedIn) navigate('/', { replace: true })
  }, [isLoggedIn, navigate])

  return (
    <div className="min-h-screen bg-[rgb(var(--np-base))] flex flex-col">
      <div className="flex justify-end p-4">
        <ThemeToggle />
      </div>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-sm">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center gap-2.5 mb-3">
              <div className="relative">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgb(var(--np-accent))" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                <div
                  className="absolute inset-0 blur-lg opacity-50"
                  style={{ background: 'rgb(var(--np-accent))' }}
                />
              </div>
              <h1 className="text-2xl font-bold tracking-brand uppercase text-[rgb(var(--np-tx-primary))]">
                ChatPulse
              </h1>
            </div>
            <p className="text-sm text-[rgb(var(--np-tx-muted))]">
              Matrix client
            </p>
          </div>

          <div className="bg-[rgb(var(--np-surface))] border border-[rgb(var(--np-border))] rounded-lg p-6">
            <LoginForm />
          </div>
        </div>
      </div>

      {/* Accent gradient line at bottom */}
      <div className="h-px bg-gradient-to-r from-transparent via-[rgb(var(--np-accent)/0.3)] to-transparent" />
    </div>
  )
}
